import * as fb from "api/lib/data/firebase";
import * as auth from "api/lib/data/auth";

let firebase: any = window.firebase;
if(firebase) {
    firebase = firebase
} else {
    firebase = fb;
}
export { auth, firebase};



// WEBPACK FOOTER //
// ./src/firebase/index.ts